import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import NavBar from './pages/layout/NavBar';
import FooterBar from './pages/layout/FooterBar';
import { AuthProvider } from './common/context';
import ScrollToTop from './components/ScrollToTop';
import NotFound from './components/NotFound';

import Home from './pages/user/HomePage';
import Aboutus from './pages/user/Aboutus';
import OurProducts from './pages/user/OurProducts';
import Announcements from './pages/user/Announcements';
import Gallery from './pages/user/Gallery';
import ContactUs from './pages/user/ContactUs';
import JoinUs from './pages/user/JoinUs';


function App() {

  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    }
  }, [])

  return (
    <AuthProvider>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <>
            <NavBar isScrolled={isScrolled} />
            <Home />
            <FooterBar />
          </>
        } />
        <Route path="/aboutus" element={
          <>
            <NavBar isScrolled={isScrolled} />
            <Aboutus />
            <FooterBar />
          </>
        } />
        <Route path="/our-products" element={
          <>
            <NavBar isScrolled={isScrolled} />
            <OurProducts />
            <FooterBar />
          </>
        } />
        <Route path="/announcements" element={
          <>
            <NavBar isScrolled={isScrolled} />
            <Announcements />
            <FooterBar />
          </>
        } />
        <Route path="/gallery" element={
          <>
            <NavBar isScrolled={isScrolled} />
            <Gallery />
            <FooterBar />
          </>
        } />
        <Route path="/contact-us" element={
          <>
            <NavBar isScrolled={isScrolled} />
            <ContactUs />
            <FooterBar />
          </>
        } />
        <Route path="/join-us" element={
          <>
            <NavBar isScrolled={isScrolled} />
            <JoinUs />
            <FooterBar />
          </>
        } />
        
        <Route path="*" element={
          <>
            <NavBar isScrolled={isScrolled} />
            <NotFound />
            <FooterBar />
          </>
        } />
      </Routes>
    </AuthProvider>
  );
}

export default App;
